import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { Utils } from '@app/_core/helper/Utils';
import { QueuesService } from '@app/_core/services/queues.service';
import { AppService } from '@app/_core/services/app.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-case-lock',
  templateUrl: './case-lock.component.html',
  styleUrls: ['./case-lock.component.scss'],
})
export class CaseLockConfirmationComponent implements OnInit {
  @Input()
  headerNames: any;
  @Input()
  localStorageName: any;
  form: FormGroup;
  headerData: any = [];
  message:any=[];
  selectedData: any;
  lockDetails:any;
  public event: EventEmitter<any> = new EventEmitter();
  showCancel: boolean=true;
  constructor(
    private appService: AppService,
    private dialerService: DialerService,
    private tmQueueService: TmQueueService,
    private queueServices: QueuesService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private webStorageService: WebStorageService,
    private router: Router,

  ) {
  }

  ngOnInit() {
    if(this.lockDetails)
    {
      this.message=this.lockDetails
      this.showCancel=false
    }
    else if(this.selectedData)
    {
      this.getAgentDetails();
    }
  }
  getAgentDetails()
  {
    this.tmQueueService.getAgent(this.selectedData.LockedBy).subscribe(
      data=>{
        this.message=data.Response.Data;
        //"This case is currently being worked upon by:" +
        //data.Response.Data.Name + "," + data.Response.Data.Email +"."+
        //"You can view this in read-only mode. Do you want to proceed?";
      }
     );
  }
  proceedWithCaseDetails()
  {
    if(this.lockDetails)
    {
      this.bsModalRef.hide();
    }
    else{
    this.dialerService.setcallEnded(false);
    const companyCode = Utils.fetch('clientAbbreviation');
    const menuName = companyCode + '/Queue/caseDetails';
    this.appService.setActionItemId(this.selectedData.ActionItemID);
    this.router.navigate([menuName]);
    this.bsModalRef.hide();
    }
  }
  cancelPopup(){
    this.bsModalRef.hide();
  }
}
